module.exports = __webpack_public_path__ + "static/media/costumer.f9ceac91.svg";